import { Button, Stack, Text } from '@mantine/core';
import { ReactElement } from 'react';

/**
 * Where a hub list would be when its read failed. A failed read must never pass for an empty list
 * (BAR-3125): "No receivables" while three wait to be invoiced is worse than an error.
 */
export function LoadFailed({
  what,
  error,
  onRetry,
}: {
  /** What didn't load, e.g. "receivables". */
  what: string;
  error: string;
  onRetry?: () => void;
}): ReactElement {
  return (
    <Stack align="center" gap={6} py={32} role="alert">
      <Text fz={13} fw={600}>{`Couldn't load ${what}`}</Text>
      <Text fz={12} c="dimmed" maw={420} ta="center">
        {error}
      </Text>
      {onRetry && (
        <Button size="xs" variant="default" onClick={onRetry}>
          Retry
        </Button>
      )}
    </Stack>
  );
}
